import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { richTextToPlainText } from "../../../utils";
import Visibility from "../content/Visibility";
import ContentComplete from "../content/ContentComplete";
import ContentLink from "../../general/ContentLink";
import { getImageSrcRelOrAbsolute } from "../../../utils";
import { DurationIndicator, ProgressBar } from "./SecondaryCollection";

const GridCollection = ({ overrideTitle, filterContent, collection, groupSlug, className }) => {
  const [isReadingMore] = useState(false);
  const { platformData } = useSelector(state => state.frontend);
  const userProgress = useSelector(state => state.content.userProgress);

  const { currentUser } = useSelector(state => state.auth);

  return (
    <div className={`pb-16 bg-platform-light-color ${className}`}>
      <div className="md:mx-auto px-0">
        <div className="text-3xl font-bold leading-normal mb-5">{overrideTitle}</div>
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 gap-y-12">
          {(collection?.Contents || []).map((content, i) => {
            if (content.id === filterContent) return null;

            const imageUrl = getImageSrcRelOrAbsolute(
              content.featuredImage || platformData.heroImage || platformData.logo,
              "?tr=w-384,h-216,q-80"
            );

            const description = richTextToPlainText(content?.description);
            const progress = userProgress.find(p => p.ContentId === content.id)?.progress;

            return (
              <li
                key={i}
                className="hover:shadow-2xl rounded-md shadow-lg overflow-hidden transition duration-500 ease-in-out"
              >
                <ContentLink
                  isInternal={content.type === "internallink"}
                  to={
                    content.type === "internallink"
                      ? content.contentURI
                      : groupSlug
                      ? `/groups/${groupSlug}/${collection.slug || "viewcontent"}/${content.id}`
                      : `/${collection.slug || "viewcontent"}/${content.id}`
                  }
                >
                  <div className="relative">
                    <div className="relative overflow-hidden">
                      <img
                        className="h-full w-full object-cover"
                        src={imageUrl}
                        alt={content.title}
                      />

                      <DurationIndicator duration={content.duration} />

                      <ProgressBar
                        progress={progress}
                        duration={content.duration}
                        primaryColor={platformData.primaryColor}
                      />
                    </div>

                    {"article" === content.type ||
                    "link" === content.type ||
                    "download" === content.type ? null : (
                      <div className="absolute flex justify-center items-center w-full h-full top-0">
                        <PlayIcon />
                      </div>
                    )}

                    <Visibility currentUser={currentUser} content={content} absolute={true} />

                    <div className="absolute top-2 left-2">
                      <ContentComplete
                        content={content}
                        buttonClass={"text-xs py-0 px-2"}
                        platformData={platformData}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="mt-3 mx-4 platform-dark-color">
                    <h2 className="mt-2 font-base font-bold line-clamp text-xl leading-6 sm:text-xl flex items-center justify-between">
                      {content.title}
                    </h2>
                  </div>
                  <div className="my-2 mx-4">
                    <span className="text-gray-700 text-xs mt-6 leading-3 font-semibold mr-4 sm:text-base sm:leading-5">
                      {content.User?.name}
                    </span>
                    <span className="text-gray-400">|</span>
                    <span className="text-gray-700 text-xs mt-2 leading-3 font-weight-normal ml-4 sm:text-base sm:leading-5">
                      ({moment(content.publishedDate || content.createdAt).fromNow()})
                    </span>
                    <div className="text-gray-700 hidden text-xs mt-2 leading-3 font-normal sm:text-base sm:leading-5">
                      {description && description.length >= 110
                        ? isReadingMore
                          ? description
                          : description.slice(0, 110) + "..."
                        : description}
                    </div>
                  </div>
                </ContentLink>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default GridCollection;

function PlayIcon() {
  return (
    <svg
      width="71"
      className="w-auto h-auto"
      height="71"
      viewBox="0 0 71 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="35.499" cy="35.5" r="35.5" fill="#fff" fillOpacity=".8"></circle>
      <path d="M50 36L26.75 48.99V23.01L50 36z" fill="#252F3F"></path>
    </svg>
  );
}
